import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";

const STATUS_COLORS = {
  completed: "success",
  pending: "warning",
  failed: "error",
};

// Turns the stored filter snapshot back into a short human summary so the
// history row says who was targeted, not just how many.
const describeFilters = (filters) => {
  if (!filters) return "All users";
  const parts = [];
  if (filters.levels?.enabled) {
    parts.push(`Levels ${(filters.levels.values ?? []).join(", ") || "none"}`);
  }
  if (filters.signupDate?.enabled) parts.push("Signup range");
  if (filters.lineupDate?.enabled) parts.push("Lineup range");
  if (filters.coinBalance?.enabled) {
    const { min, max } = filters.coinBalance;
    parts.push(
      `Balance ${min === "" || min == null ? "any" : min} - ${
        max === "" || max == null ? "any" : max
      }`
    );
  }
  if (filters.completedProfile?.enabled) {
    parts.push(`Profile ${filters.completedProfile.value ? "complete" : "incomplete"}`);
  }
  if (filters.payingUser?.enabled) {
    parts.push(filters.payingUser.value ? "Paying" : "Non-paying");
  }
  return parts.length > 0 ? parts.join(" · ") : "All users";
};

export default function UserRewardsHistoryTable({ rows }) {
  if (!rows || rows.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: "text.secondary", p: 3 }}>
        No rewards have been sent yet.
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Transaction Name</TableCell>
            <TableCell>Amount</TableCell>
            <TableCell>Users</TableCell>
            <TableCell>Audience</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Admin</TableCell>
            <TableCell>Sent</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.userRewardBatchId}>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.transactionName}</TableCell>
              <TableCell>{row.amount?.toLocaleString()}</TableCell>
              <TableCell>{row.userCount?.toLocaleString()}</TableCell>
              <TableCell sx={{ maxWidth: 260 }}>
                <Typography variant="caption">
                  {describeFilters(row.filters)}
                </Typography>
              </TableCell>
              <TableCell>
                {row.status === "failed" && row.error ? (
                  <Tooltip title={row.error}>
                    <Chip label="failed" color="error" size="small" />
                  </Tooltip>
                ) : (
                  <Chip
                    label={row.status}
                    color={STATUS_COLORS[row.status] ?? "default"}
                    size="small"
                  />
                )}
              </TableCell>
              <TableCell>{row.adminUsername ?? "--"}</TableCell>
              <TableCell>{fDateTime(row.createdAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
